 
      <div style="max-width:400px; position:relative; padding-bottom:40px; min-width:320px;  margin:0px auto;" class="col-xs-12">
        
	<div class="reg"> <a style="margin:0"  class="forgot-password caption-2 link"
                         [routerLink]="['/registration']">Зареєструватися</a> </div>
     <!--   <div class="logo-wrapper">

            <img class="logo" src="assets/logo.png"  />
        </div> -->

        <p class="sub-title">Увійти в Особистий кабінет</p>
        
        <div class="">
          <div>
           
            <form  [formGroup]="form" (ngSubmit)="submit()" >
              <div class="form-group">

                <div>
                  

                    <span class="label-with-link ">
                      <label for="email" class="label">Email:</label>
                      
                    <!----> 
                      </span>
  

                <input  nbInput    fullWidth  id="email" formControlName="email" 
                placeholder="Введіть email" type="email"
                [ngClass]="{invalid:form.get('email').invalid && form.get('email').touched}" />
              </div>
                <span *ngIf="form.get('email').invalid && form.get('email').touched" class="caption status-danger">
                 <span *ngIf="form.get('email').errors.required">Обов'язкове поле</span>
                 <span *ngIf="form.get('email').errors.email">Введіть коректну email адресу</span>
                </span>
              </div>
              <div class="form-group">

                <div>

                  <span class="label-with-link ">
                    <label for="password" class="label">Пароль:</label>
                    
                    </span>

                <input 
                nbInput fullWidth
                 id="password"
                formControlName="password"
                placeholder="Введіть пароль"
                type="password"
                [ngClass]="{invalid:form.get('password').invalid && form.get('password').touched}"   />
             </div>
                <span *ngIf="form.get('password').invalid && form.get('password').touched" class="caption status-danger">
                 <span *ngIf="form.get('password').errors.required">Обов'язкове поле</span>
                 <span *ngIf="form.get('password').errors.minlength"> 
                   
                   
                  Мінімальна довжина пароля {{form.get('password').errors.minlength.requiredlength}} символів.
				Зараз {{form.get('password').errors.minlength.actualLength }}
                 </span>
                </span>
              </div>
 

               <div style="text-align:right;">
              
                    <a   class="forgot-password caption-2 link"
                       [routerLink]="['/reset-password']" >Забули пароль?</a>
               </div>

              <div class="submit-wrapper">
                <button  nbButton fullWidth size="large" status="primary"  [disabled]="form.invalid || form.disabled"
                type="submit">Увійти</button>
              </div>
            </form>
           
          </div>
 
      </div>
    </div>
  
